import {cn} from "lib/utils";

/** Loading state for a page that is still coming off the press. */
function Skeleton({className, ...props}) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-sm bg-surface-2",
        "after:absolute after:inset-0 after:-translate-x-full",
        "after:bg-gradient-to-r after:from-transparent after:via-paper/50 after:to-transparent",
        "after:animate-[shimmer_1.6s_infinite]",
        className
      )}
      {...props}
    />
  );
}

export {Skeleton};
